export default __webpack_public_path__ + "assets/models/cc1ec5dfdf46fe1653ec562c2da1c7cb.glb";